import React, { useState, useRef, useEffect } from "react";

import "./ClientesAutocomplete.scss";
const ClientesAutocomplete = ({
  cliente,
  allClientes,
  setCliente,
  className = "editavaliacaoPickMedcoContainer__element",
}) => {
  const [inputValue, setInputValue] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const [filteredClientes, setFilteredClientes] = useState([]);
  const [isFocused, setIsFocused] = useState(false);

  const wrapperRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (cliente) {
      setInputValue(cliente.label);
    } else {
      setInputValue("");
    }
  }, [cliente]);

  // Função para remover acentos
  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const filterClientes = (searchText) => {
    if (!searchText) return allClientes;

    const searchTerms = removeAccents(searchText.toLowerCase()).split(/\s+/);

    return allClientes
      .sort((a, b) => {
        const aStartsWith = removeAccents(a.label.toLowerCase()).startsWith(
          searchTerms[0]
        );
        const bStartsWith = removeAccents(b.label.toLowerCase()).startsWith(
          searchTerms[0]
        );
        if (aStartsWith && !bStartsWith) return -1;
        if (!bStartsWith && aStartsWith) return 1;
        return a.label.localeCompare(b.label);
      })
      .filter((cliente) => {
        const normalizedName = removeAccents(cliente.label.toLowerCase());
        const nameWords = normalizedName.split(/\s+/);

        return searchTerms.every((term) =>
          nameWords.some((word) => word.includes(term))
        );
      });
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setShowSuggestions(true);
    setFilteredClientes(filterClientes(value));
    setFocusedIndex(-1);

    if (!value) {
      setCliente(null);
    }
  };

  const handleSelectClient = (cliente) => {
    setInputValue(cliente.label);
    setShowSuggestions(false);
    setCliente(cliente);
    inputRef.current?.blur();
  };

  const handleKeyDown = (e) => {
    if (!showSuggestions) return;

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setFocusedIndex((prev) =>
          prev < filteredClientes.length - 1 ? prev + 1 : prev
        );
        break;
      case "ArrowUp":
        e.preventDefault();
        setFocusedIndex((prev) => (prev > 0 ? prev - 1 : -1));
        break;
      case "Enter":
        e.preventDefault();
        if (focusedIndex >= 0 && filteredClientes[focusedIndex]) {
          handleSelectClient(filteredClientes[focusedIndex]);
        }
        break;
      case "Escape":
        setShowSuggestions(false);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
        if (cliente) {
          setInputValue(cliente.label);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [cliente]);

  return (
    <div
      ref={wrapperRef}
      className={`clienteAutocompleteUtil-wrapper ${className}`}
    >
      <div
        className={`clienteAutocompleteUtil-input-container ${
          isFocused ? "focused" : ""
        } ${inputValue ? "has-value" : ""}`}
      >
        <input
          ref={inputRef}
          type="text"
          className="clienteAutocompleteUtil-input"
          value={inputValue}
          onChange={handleInputChange}
          onFocus={() => {
            setIsFocused(true);
            setShowSuggestions(true);
            setFilteredClientes(filterClientes(inputValue));
          }}
          onBlur={() => setIsFocused(false)}
          onKeyDown={handleKeyDown}
          placeholder="Clientes"
        />
        <label className="clienteAutocompleteUtil-label">Cliente</label>
      </div>

      {showSuggestions && filteredClientes.length > 0 && (
        <div className="clienteAutocompleteUtil-suggestions">
          {filteredClientes.map((cliente, index) => {
            const sameNameClientes = filteredClientes.filter(
              (c) => c.label === cliente.label
            );
            const isDuplicate = sameNameClientes.length > 1;

            return (
              <div
                key={cliente.id}
                className={`clienteAutocompleteUtil-suggestion ${
                  focusedIndex === index ? "focused" : ""
                }`}
                onClick={() => handleSelectClient(cliente)}
              >
                <div>
                  {cliente.label}
                  {isDuplicate && (
                    <span className="clienteAutocompleteUtil-client-id">
                      ID: #{cliente.id.slice(-4)}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ClientesAutocomplete;
